var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.414 0 0 1.414l4.243 4.243L0 9.899l1.414 1.415L5.657 7.07l4.242 4.243 1.415-1.415L7.07 5.657l4.243-4.243L9.899 0 5.657 4.243 1.414 0Z",
    fill: "currentColor"
  })));
};
export default SvgCancel;